'use strict';

export function snakeCase (word = '') {
  return word.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export function escapeStringRegexp (str: string): string {
  return str.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
}

export function generateRandomString (length: number) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
}

export function capitalize (string: string) {
  return !string.length ? '' : `${string[0].toUpperCase()}${string.slice(1).toLowerCase()}`;
}
